<template>
  <v-app class="lk" style="background: #f5f5f6">
    <Alert></Alert>
    <Loading></Loading>
    <RedirectModal />
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import CabinetLayout from "@/layouts/CabinetLayout.vue";
import Alert from "@/components/common/Alert.vue";
import Loading from "@/components/common/Loading.vue";
import RedirectModal from "@/components/common/RedirectModal.vue";

// импортим лайауты как название свойства meta.layout в роутере компонента
export default {
  components: {
    Alert,
    Loading,
    RedirectModal,
    EmptyLayout,
    CabinetLayout,
  },
  computed: {
    layout() {
      const metaLayout = this.$route.meta.layout || "empty";
      return `${metaLayout}-layout`;
    },
  },

  // data: () => ({})
};
</script>

<style lang="scss">
@import "@/styles/main";

.lk {
  &.v-application.theme--light {
    color: $blue3;
  }
  & .text-link {
    color: inherit;
  }
}
.lk {
  @media (max-width: 600px) {
    background: #ffffff !important;
  }
}
</style>
